<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="720px" :fullscreen="$vuetify.breakpoint.xsOnly" persistent fluid scrollable)
  v-card
    v-card-title.px-4
      v-spacer
      h6.ml-10 {{ $t('message_template') }}
      v-spacer
      v-btn(icon @click="showDialog = false")
        v-icon mdi-close
    v-divider

    v-card-text.py-4
      connect-message-template(:message.sync="finalMessage")
    v-divider

    v-card-actions.py-4.px-6
      v-spacer
      v-btn.button-Aa-medium.px-4.primary400--text(@click="showDialog = false" text height=40) {{ $t('cancel') }}
      v-btn.button-Aa-medium.px-4.white--text(@click="update" :loading="isLoading" color="info500" depressed height=40 :disabled="!finalMessage") {{ $t('update') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ConnectMessageTemplate from '@/components/connect/ConnectMessageTemplate'

export default {
  components: { ConnectMessageTemplate },
  props: ['open', 'task'],
  data: () => ({
    isLoading: false,
    finalMessage: ''
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  created () {
    if (this.task.template?.length) {
      this.finalMessage = this.task.template[0].template
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    update () {
      this.isLoading = true
      if (this.task.template?.length) {
        const id = this.task.template[0].id
        this.$axios.put(`/connect/${this.company.slug}/tasks/templates/${id}`, { template: this.finalMessage })
          .then(() => {
            this.showDialog = false
            this.showMessage(['success', this.$t('success_message.template_updated_successfully')])
            this.$emit('updated')
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_update_template')])
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        this.createTemplate()
      }
    },
    createTemplate () {
      this.isLoading = true
      const params = {
        template: this.finalMessage
      }
      this.$axios.post(`/connect/${this.company.slug}/tasks/templates`, params)
        .then(resp => {
          const templateId = resp.data.id
          this.patchTask(templateId)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_update_template')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    patchTask (templateId) {
      this.isLoading = true
      this.$axios.patch(`/connect/${this.company.slug}/tasks/${this.task.id}`, { template: [templateId] })
        .then(() => {
          this.showMessage(['success', this.$t('success_message.template_updated_successfully')])
          this.$emit('updated')
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_update_template')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>